export default {
  isLoading: false,
  isLoadingTypes: false,
  paymentMethods: [],
  paymentMethodsTypes: [],
};
